import { motion } from 'framer-motion';
export default function WhyChooseUS() {
  return (
    <section
      style={{ backgroundImage: `url('/whychooseusbg.jpg')` }}
      className="relative mt-[3rem] w-full overflow-hidden bg-cover pb-[2rem] font-inter md:mt-[6rem] lg:mt-[10rem]"
    >
      <div
        className="absolute left-0 top-0 z-[0] h-full w-full"
        style={{ backgroundImage: 'linear-gradient(180deg, #00142CF5 49%, #00142CFA 100%)  ' }}
      ></div>
      {/* --- IMAGE ON RIGHT EDGE --- */}
      <motion.div
        className="relative inset-y-0 right-0 z-[1] hidden w-full rounded-md md:block lg:absolute lg:w-[45vw]"
        initial={{ x: 200, opacity: 0 }} // start off to the right
        whileInView={{ x: 0, opacity: 1 }} // slide to original position
        transition={{ duration: 0.8, ease: 'easeOut' }} // adjust speed
        viewport={{ once: true, amount: 0.5 }} // trigger once when 50% in view
      >
        <img
          src="/whychooseuscreptivity.jpg"
          className="z-[5555] h-full w-full rounded-md object-cover md:object-[70%_0%]"
          alt="constructor"
        />
      </motion.div>
      <img
        src="/whychooseuscreptivity.jpg"
        className="relative z-[5555] h-auto w-full rounded-md object-cover md:hidden md:object-[70%_0%]"
        alt="constructor"
      />
      {/* --- MAIN CONTENT MAX WIDTH --- */}
      <div className="relative mx-auto flex max-w-[116rem] px-[2rem]">
        {/* LEFT TEXT COLUMN (60rem) */}
        <div className="mt-[3rem] w-full pr-[2rem] lg:mt-0 lg:w-[60rem]">
          <motion.h1
            initial={{ opacity: 0, x: 400 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.5 }} // triggers when 50% in view
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="text-[1.6rem] font-[600] leading-[2.6rem] text-[#0EC9AC] md:pt-[3rem] md:text-[1.8rem] md:leading-[2.8rem]"
          >
            Why Choose Us
          </motion.h1>

          <h1 className="mt-[2rem] text-[2.4rem] font-[600] leading-[3.2rem] text-white lg:text-[3.6rem] lg:leading-[4.6rem]">
            Provide Advanced Security for Advanced Threats
          </h1>

          <p className="mt-[3rem] text-[1.6rem] leading-[2.4rem] text-[#999]">
            At NEXT-G Services, we understand that modern businesses face modern risks. That’s why
            we combine experienced security personnel with smart technology and proactive planning.
            Whether you manage a single site or multiple locations across the UK, we deliver
            reliable protection tailored to your environment, your people and your operations.
          </p>
          <div className="mt-[3rem] flex w-full flex-wrap justify-between">
            <div className="flex w-[48.5%] flex-col gap-[2rem]">
              <img
                src="/highqualityservice.png"
                alt="high quality service"
                className="h-[4rem] w-[4rem]"
              />
              <h1 className="text-[2.4rem] font-[600] leading-[3.2rem] text-white">
                Rapid Response & Coverage
              </h1>
              {/* <p className="text-[1.6rem] leading-[2.4rem] text-[#999]">
                We combine experienced, vetted security professionals with clear communication and
                responsive support. Every contract is managed proactively, with regular reviews to
                ensure our service consistently meets your standards.
              </p> */}
            </div>
            <div className="flex w-[48.5%] flex-col gap-[2rem]">
              <img
                src="/effectiveprotection.png"
                alt="effective protection"
                className="h-[4rem] w-[4rem]"
              />
              <h1 className="text-[2.4rem] font-[600] leading-[3.2rem] text-white">
                Proactive Risk Monitoring
              </h1>
              {/* <p className="text-[1.6rem] leading-[2.4rem] text-[#999]">
                Our security solutions are designed around real risks, not guesswork. Through smart
                planning, visible presence and rapid response, we help deter crime, reduce incidents
                and create a safer environment for staff, visitors and customers.
              </p> */}
            </div>
            <div className="mt-[2rem] flex w-full flex-col gap-[2rem]">
              <img
                src="/effectiveprotection.png"
                alt="effective protection"
                className="h-[4rem] w-[4rem]"
              />
              <h1 className="text-[2.4rem] font-[600] leading-[3.2rem] text-white">
                24/7 Support & Reliability
              </h1>
              <p className="text-[1.6rem] leading-[2.4rem] text-[#999]">
                Our operations team is available around the clock to support both clients and
                officers. You get clear communication, consistent cover and the peace of mind that
                your security is never an afterthought.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
